import React from 'react';
import { LinkedinIcon, MailIcon, MapPinIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-900 text-white py-16 px-6" data-id="element-92">
      <div className="max-w-7xl mx-auto" data-id="element-93">
        <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-94">
          <div data-id="element-95">
            <h3 className="text-2xl font-bold mb-4" data-id="element-96">Enlaces Consultora</h3>
            <p className="text-slate-400 leading-relaxed" data-id="element-97">
              Especialistas en selección de personal y desarrollo de capital
              humano.
            </p>
          </div>

          <div data-id="element-98">
            <h4 className="font-semibold mb-4" data-id="element-99">Contacto</h4>
            <div className="space-y-3 text-slate-400" data-id="element-100">
              <div className="flex items-start" data-id="element-101">
                <MapPinIcon className="w-5 h-5 mr-2 flex-shrink-0 mt-0.5" data-id="element-102" />
                <span data-id="element-103">
                  Buenos Aires y Córdoba.
                  <br data-id="element-104" />
                  Cobertura Nacional
                </span>
              </div>
              <div className="flex items-center" data-id="element-105">
                <MailIcon className="w-5 h-5 mr-2 flex-shrink-0" data-id="element-106" />
                <a href="mailto:info@enlacesconsultora.com" className="hover:text-emerald-400 transition-colors" data-id="element-107">
                  info@enlacesconsultora.com
                </a>
              </div>
            </div>
          </div>

          <div data-id="element-108">
            <h4 className="font-semibold mb-4" data-id="element-109">También estamos en redes</h4>
            <div className="flex space-x-4" data-id="element-110">
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-emerald-500 transition-colors" data-id="element-111">
                <LinkedinIcon className="w-5 h-5" data-id="element-112" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-emerald-500 transition-colors" data-id="element-113">
                <InstagramIcon className="w-5 h-5" data-id="element-114" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-slate-400" data-id="element-115">
          <p data-id="element-116">
            Enlaces® es una marca registrada. Queda prohibida su reproducción
            total o parcial sin autorización previa.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-117">
            <a href="#" className="hover:text-emerald-400 transition-colors" data-id="element-118">
              Aviso de Privacidad
            </a>
            <a href="#" className="hover:text-emerald-400 transition-colors" data-id="element-119">
              Política de Confidencialidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
}